import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export interface RailPanelProps {
  title: string;
  tagline?: string;
  children: ReactNode;
  className?: string;
}

export function RailPanel({
  title,
  tagline,
  children,
  className,
}: RailPanelProps) {
  return (
    <section
      className={twMerge(
        'rounded-lg border border-gray-200 bg-white p-4 font-inter',
        className
      )}
    >
      <div className='mb-3 flex items-baseline justify-between gap-2'>
        <h3 className='text-sm font-semibold text-gray-900'>{title}</h3>
        {tagline && (
          <span className='shrink-0 text-xs text-gray-400'>{tagline}</span>
        )}
      </div>
      {children}
    </section>
  );
}
